/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotLinesOfCodeSummaryBase extends models.CopilotActivityCountBase {
    getFixupPrototypeFunction() { return CopilotLinesOfCodeSummaryBase.fixupPrototype; }

    static newInstance(model: Partial<CopilotLinesOfCodeSummaryBase>): CopilotLinesOfCodeSummaryBase {
        let obj = Object.assign(new CopilotLinesOfCodeSummaryBase(), model);
        CopilotLinesOfCodeSummaryBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotLinesOfCodeSummaryBase>): CopilotLinesOfCodeSummaryBase {
        if (!model) return null;
        return CopilotLinesOfCodeSummaryBase.newInstance(<CopilotLinesOfCodeSummaryBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotLinesOfCodeSummaryBase) {
        if (!obj) return;

        models.CopilotLinesOfCodeSummaryBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotLinesOfCodeSummaryBase): boolean {
        if (models.CopilotActivityCountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotLinesOfCodeSummaryBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.lines_of_code_added_sum === undefined) {
            this.lines_of_code_added_sum = 0;
        }
        if (this.lines_of_code_suggested_sum === undefined) {
            this.lines_of_code_suggested_sum = 0;
        }
        if (typeof this.day === "string") {
            this.day = new Date(<string><any>this.day);
        }
    }

    /**
     * Date of the metrics record
     */
    day: Date;

    /**
     * Total number of lines added
     */
    lines_of_code_added_sum: number;

    /**
     * Total number of lines suggested
     */
    lines_of_code_suggested_sum: number;

}
